export interface SchemaDependency {
  key: string;
  type: 'many' | 'one';
}

export interface SchemaTreeEntry {
  name?: string;
  dependencies: SchemaDependency[];
}

export type SchemaTree = Record<string, SchemaTreeEntry>;

const schemaTree: SchemaTree = {
  user: {
    dependencies: [],
  },
  state: {
    dependencies: [],
  },
  value: {
    dependencies: [
      {
        key: 'state',
        type: 'many',
      },
    ],
  },
  device: {
    dependencies: [
      {
        key: 'value',
        type: 'many',
      },
    ],
  },
  network: {
    dependencies: [
      {
        key: 'device',
        type: 'many',
      },
    ],
  },
  permission: {
    dependencies: [],
  },
  acl: {
    dependencies: [
      {
        key: 'permission',
        type: 'many',
      },
    ],
  },
};

export default schemaTree;
